export default __webpack_public_path__ + "static/media/services_dev_1.0f2e7670.jpg";